<template>
<div>
    <div v-if="listOrGrid === undefined || listOrGrid === true || listOrGrid === ''"  class="d-flex flex-row flex-column-fluid custom-card mt-3 mb-3">
            <div class="card card-custom w-100  bg-hover-state-custom  border-secondary">
                <div v-if="selectedVariant">
                    <div v-if="selectedVariant.formatted_images.default_image.length > 0" class="bg-img-height photo" :style="`background-image: url(${getBrandImageUrl(selectedVariant.formatted_images.default_image)})`" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false">
                        <div class="overlay">
                            <p>{{$t('view')}} {{$t('details')}}...</p>
                        </div>
                   
                    </div>
                    <div v-else   class="bg-img-height photo" :style="`background-image: url(${getBrandImageUrl('/images/no-image-500x500.jpg')})`" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left" data-backdrop="static" data-keyboard="false">
                    <div class="overlay">
                            <p>{{$t('view')}} {{$t('details')}}...</p>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <div v-if="product.is_bundle" class="card-header-right ribbon ribbon-clip ribbon-left" style="right: 0px;">
                        <div class="ribbon-target" style="top: 0px;">
                            <span class="ribbon-inner bg-primary"></span>
                            Bundle
                        </div>
                    </div>
                    <div v-if="product.formatted_images.default_image.length > 0" class="bg-img-height photo" :style="`background-image: url(${getBrandImageUrl(product.formatted_images.default_image)})`" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false">
                        <div class="overlay">
                            <p>{{$t('view')}} {{$t('details')}}...</p>
                        </div>
                    </div>
                    <div v-else   class="bg-img-height photo" :style="`background-image: url('/images/no-image-500x500.jpg')`" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left" data-backdrop="static" data-keyboard="false">
                    <div class="overlay">
                            <p>{{$t('view')}} {{$t('details')}}...</p>
                        </div>
                    </div>
                </div>
               <div class="separator separator-solid"></div>
               <div class="card-header">
                   <div class="d-flex align-items-center ">
                        <div class="">
                            <div class="font-weight-bolder font-size-lg ">
                                <a href="javascript:void(0);" :style="hyperlinkColor"  class=" font-size-h4" :class="{ 'demo-product-name': $store.getters.brand['subdomain'] === 'mettahemp' }" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left" :data-original-title="productName" :title="$store.getters.brand['subdomain'] === 'mettahemp' ? product.n : null">{{$store.getters.brand['subdomain'] === 'mettahemp' ? product.n : (product.n.length < 25 ? product.n : product.n.slice(0,25) + ' ....')}}
                                </a>
                            </div>
                            <span class="text-muted mt-5" v-if="!($store.getters.role =='customer-contact' && $store.getters.brand.hide_sku_on_shop=='1')">{{product.sku.length < 30 ? product.sku : product.sku.slice(0,30) + ' ....'}}</span>
                        </div>
                   </div>
               </div>
               <div class="card-body" style="min-height: 120px">
                <div v-if="!product.hasVariants && $store.getters.brand.show_available_inventory_customer_shop=='1'"
                    class="d-flex align-items-center justify-content-between">
                    <span class="font-weight-bolder mr-2 text-muted">{{$t('Available Inventory')}}</span>
                    <span v-if="product.ti !== 0" class="font-weight-bolder text-muted"> {{Number.isInteger(product.inventory) ? product.inventory : product.inventory.toFixed(2)}}</span>
                    <span v-else class="font-weight-bolder text-muted">∞</span>
                </div>
                <div v-if="product.hasVariants && $store.getters.brand.show_available_inventory_customer_shop=='1'"
                    class="d-flex align-items-center justify-content-between">
                    <span class="font-weight-bolder mr-2 text-muted">{{$t('Available Inventory')}}</span>
                    <span v-if="selectedVariant.track_inventory !== 0" class="font-weight-bolder text-muted">{{selectedVariant.inventory}}</span>
                    <span v-else class="font-weight-bolder text-muted">∞</span>
                </div>
                <div v-if="!product.hasVariants && $store.getters.brand.hide_price_shop_view=='0'"
                    class="d-flex align-items-center justify-content-between mt-3 mb-2">
                    <!-- <code class="font-weight-bolder font-size-h1 bg-white"></code>  -->
                    <span class="font-weight-bolder font-size-h6 mr-2" style="color:#e76450">{{$t('price')}}</span>
                    <span class=" text-hover-primary font-weight-bolder font-size-h6"
                        style="color:#e76450 !important"> {{product.currency_symbol}}{{productPrice}}</span>
                </div>
                <div v-if="product.hasVariants" class="d-flex align-items-center justify-content-between mobile-grid-variant-select">
                    <select class="form-control" :id="'var_' + product.id" :name="'var_' + product.id"
                        v-model="selectedVariant" @change="updateVariant($event)">
                        <button type="button" class="variant-select-button">
                            <selectedcontent class="variant-selected-content"></selectedcontent>
                        </button>
                        <option disabled :data-id="product.id" value="">{{$t('select_variant')}}</option>
                        <option v-for="(varProduct, index) in product.variants" :key="index"
                            v-bind:value="varProduct">
                            <!-- Implement the STore setting hide price in shop view  -->
                            <div v-if="$store.getters.brand.hide_price_shop_view=='0'">
                                <div>
                                    <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name ? varProduct.name : varProduct.n}} -
                                        {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price)}}</h2>
                                    <h2
                                        v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">
                                        {{varProduct.name ? varProduct.name : varProduct.n}} -
                                        {{varProduct.currency_symbol}}{{commaSeprator(varProduct.price)}}</h2>
                                    <h2 v-else>{{varProduct.name ? varProduct.name : varProduct.n}} -
                                        {{varProduct.currency_symbol}}{{commaSeprator(varProduct.low_price)}} ---
                                        {{varProduct.currency_symbol}}{{commaSeprator(varProduct.high_price)}}</h2>
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name ? varProduct.name : varProduct.n}}</h2>
                                    <h2
                                        v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">
                                        {{varProduct.name ? varProduct.name : varProduct.n}}</h2>
                                    <h2 v-else>{{varProduct.name ? varProduct.name : varProduct.n}}</h2>
                                </div>
                            </div>
                        </option>
                    </select>
                </div> 
                 
                <div class="">
                    <div class="d-flex  justify-content-between  mt-2" v-if="!buttonSoldOut">
                        <template v-if="$store.state.brand_settings['allow_decimal_order_quantity'] == '1' ">
                            <input class="form-control form-elements" :id="product.id + '-quantity'" type="number" :min="minValue"
                            :step="step" placeholder="Add Quantity"
                            :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity"
                            :value="showMinProductQuantity" @change="handleInput(product)"
                            :disabled="quantityDisable" v-on:keyup.enter="addProductToCart(product)" style="width: 50%">
                        </template>
                        <template v-else>
                            <input class="form-control form-elements" :id="product.id + '-quantity'" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" :min="minValue"
                            :step="step" placeholder="Add Quantity"
                            :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity"
                            :value="showMinProductQuantity" @change="handleInput(product)"
                            :disabled="quantityDisable" v-on:keyup.enter="addProductToCart(product)" style="width: 50%">
                        </template>
                        <button :id="product.id + '-cartButton'" :class="btnClass" @click="addProductToCart(product)" :disabled="cartDisable">{{btnText}}</button>
                    </div>
                    <div v-else class="mt-2">
                        <button type="button" class="btn btn-secondary form-control">{{$t('sold_out')}}</button>
                    </div>
                </div>
               </div>
                
           </div>
    </div>
    <div v-else class="card card-custom mobile-list-card">
        <div class="card-body">
             <div  class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded" id="kt_datatable" style="">
        <table class="datatable-table mobile-product-list" style="display: block;">
            <tbody style="" class="datatable-body">
                <tr class="datatable-row" :class="{ 'mobile-variant-row': product.hasVariants }" style="left: 0px;">
                    <td data-field="ShipName" data-autohide-disabled="true" class="datatable-cell">
                        <span style="width: 270px;">
                            <div class="d-flex align-items-center" >
                                 <div v-if="selectedVariant" class="symbol symbol-40 symbol-sm flex-shrink-0 ml-4">
                                    <img v-if="selectedVariant.formatted_images.default_image.length > 0" :src="getBrandImageUrl(selectedVariant.formatted_images.default_image)" alt="photo" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false"/>
                                    <img v-else src="/images/no-image-500x500.jpg" alt="photo" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false"/>

                                </div>
                                <div v-else class="symbol symbol-40 symbol-sm flex-shrink-0 ml-4">
                                    <img v-if="product.formatted_images.default_image.length > 0" :src="getBrandImageUrl(product.formatted_images.default_image)" alt="photo" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false"/>
                                    <img v-else src="/images/no-image-500x500.jpg" alt="photo" data-toggle ="modal"  data-target="#generalModal" @click="$emit('openDetails',product)" data-placement="left"  data-backdrop="static" data-keyboard="false"/>
                                </div>
                                <div class="ml-4">
                                    <div class=" font-weight-bolder font-size-lg mb-0">
                                        <a :style="hyperlinkColor" class="font-size-h6" href="javascript:void(0);" data-toggle ="modal"  data-target="#generalModal" data-backdrop="static" data-keyboard="false" @click="$emit('openDetails',product)">{{product.n }} </a>
                                    </div>
                                </div>
                                <span id="bundle_icon" v-if="product.is_bundle" class="label label-primary label-inline font-weight-bolder text-capitalize ml-1" style="cursor:pointer;"  data-toggle ="modal"  data-target="#generalModal" data-backdrop="static" data-keyboard="false" @click="$emit('openDetails',product)"> <i class="mr-1 fas fa-info icon_style"></i> Bundle</span>
                            </div>
                        </span>
                    </td>
                    <td class="datatable-cell">
                        <span style="width: 110px;">{{product.sku}}</span>
                    </td>
                    
                    <td  class="datatable-cell">
                        <span style="width: 200px;">
                            <div class="d-flex align-items-center">
                                <div v-if="product.hasVariants" class="d-flex align-items-center justify-content-between mb-2">
                                    <select class="form-control" :id="'var_' + product.id" :name="'var_' + product.id" v-model="selectedVariant" @change="updateVariant($event)">
                                        <button type="button" class="variant-select-button">
                                            <selectedcontent class="variant-selected-content"></selectedcontent>
                                        </button>
                                        <option disabled :data-id="product.id" value="">{{$t('select_variant')}}</option>
                                        <option v-for="(varProduct, index) in product.variants" :key="index"  v-bind:value="varProduct">
                                        <div v-if="$store.getters.brand.hide_price_shop_view=='0'">
                                            <div>
                                                <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name ? varProduct.name : varProduct.n}} -- {{varProduct.currency_symbol}}{{commaSeprator(varProduct.price)}}</h2>
                                                <h2 v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">{{varProduct.name ? varProduct.name : varProduct.n}} - {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price) }}</h2>
                                                <h2 v-else>{{varProduct.name ? varProduct.name : varProduct.n}} - {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.low_price) }} --- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.high_price) }}</h2>
                                            </div>
                                        </div>  
                                        <div v-else>
                                            <div>
                                                <h2 v-if="!varProduct.uses_volume_price_tiers">{{varProduct.name ? varProduct.name : varProduct.n}} -- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price)}}</h2>
                                                <h2 v-else-if="varProduct.uses_volume_price_tiers && varProduct.hasOwnProperty('price')">{{varProduct.name ? varProduct.name : varProduct.n}} - {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.price)}}</h2>
                                                <h2 v-else>{{varProduct.name ? varProduct.name : varProduct.n}} - {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.low_price) }} --- {{varProduct.currency_symbol}}{{ commaSeprator(varProduct.high_price) }}</h2>
                                            </div>
                                        </div> 
                                        </option>
                                    </select>
                                </div>
                                <div v-if="!product.hasVariants && $store.getters.brand.hide_price_shop_view=='0'">
                                    <span  class="font-weight-bold mr-2"><b>{{$t('price')}}</b></span>
                                    <div align="center" class="text-hover-primary">
                                        <span>{{product.currency_symbol}}{{ productPrice }}</span>
                                    </div>
                                </div>
                                
                            </div>
                        </span>
                    </td>
                    <td class="datatable-cell">
                        <div v-if="!product.hasVariants && $store.getters.brand.show_available_inventory_customer_shop=='1'"
                            class="d-flex align-items-center justify-content-between">
                            <span class="text-hover-primary"> {{Number.isInteger(product.inventory) ? product.inventory : product.inventory.toFixed(2)}}</span>
                        </div>
                        <div v-if="product.hasVariants && $store.getters.brand.show_available_inventory_customer_shop=='1'"
                            class="d-flex align-items-center justify-content-between">
                            <span class="text-hover-primary">{{selectedVariant.inventory}}</span>
                        </div>
                    </td>
                
                    <td class="datatable-cell">
                        <div class="row" style="width: 252px;">
                            <div class="col-md-6">
                                <template v-if="$store.state.brand_settings['allow_decimal_order_quantity'] == '1' ">
                                    <input class="form-control form-elements" :id="product.id + '-quantity'" type="number" v-if="!buttonSoldOut" :min="minValue" :step="step" :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity" placeholder="Add Quantity" :value="showMinProductQuantity" :disabled="quantityDisable"  v-on:keyup.enter="addProductToCart(product)">
                                </template>
                                <template v-else>
                                    <input class="form-control form-elements" onkeypress="return event.charCode >= 48 && event.charCode <= 57" :id="product.id + '-quantity'" type="number" v-if="!buttonSoldOut" :min="minValue" :step="step" :max="product.max_pur_qty ? product.max_pur_qty : ProductMaxQuantity" placeholder="Add Quantity" :value="showMinProductQuantity" :disabled="quantityDisable"  v-on:keyup.enter="addProductToCart(product)">
                                </template>
                            </div>
                            <div class="col-md-6">
                                <button v-if="!buttonSoldOut" :id="product.id + '-cartButton'" :class="btnClass" @click="addProductToCart(product)" :disabled="cartDisable" style="width: max-content">{{btnText}}</button>
                                <button v-else class="btn btn-secondary form-control">{{$t('sold_out')}}</button>
                            </div>
                        </div>
                    </td>
                   
                </tr>
            </tbody>
        </table>
    </div>
        </div>
    </div>
</div>
</template>
<script setup>
// import Notifications from 'vue-notification';
import ShopAPIService from '@/js/api/store/shop';
import { ref, defineProps, watch, onMounted, computed} from 'vue';
import eventBus from '@/js/utils/eventBus';
import { useI18n } from 'vue-i18n';
import {toast} from "vue3-toastify";
import 'vue3-toastify/dist/index.css';
import { useStore } from 'vuex';
import { getBrandImageUrl } from '@/js/utils/common.js';

const props = defineProps ({
    product: {
        type: Object,
        required: true,
    },
    listOrGrid: {
        type: Boolean,
        required: true,
    },
    settings: {
        type: Object,
        required: true,
    },
    // When we filter a category and select a varaint product and then clear the filter the vairant product image are not reset, it's showing the selected variant product image
});

const cartDisable = ref(false);
const min = ref(1);
const step = ref(1);
const quantityValue = ref(0);
const selectedVariant = ref('');
const quantityDisable = ref(false);
const btnClass = ref('btn btn-success form-control unset-bg-color ml-2');
const { t } = useI18n();
const btnText = ref(t('add_to_cart'));
const productPrice = ref(0);
const enableVariantPrice = ref(false);
const productName = ref(props.product.n);
const ProductMaxQuantity = ref(999999);
const buttonSoldOut = ref('');
const store = useStore();
const APIURL = import.meta.env.VITE_API_URL;

watch(selectedVariant, (variant) => {
  if (props.product.hasVariants && variant) {
    cartDisable.value = false;
    quantityDisable.value = false;
  } else {
    cartDisable.value = true;
    quantityDisable.value = true;
  }
});

watch(() => props.product, (product) => {
  checkPriceTier(product);
  disableCartButton();
  checkProductSoldOut(product);
});

onMounted(() => {
  checkMinPurchaseQty(props.product);
  checkPriceTier(props.product);
  disableCartButton();
  checkProductSoldOut(props.product);
  enableVariantPrice.value = (!props.product.hasVariants) ? true : false;
});
/* When we enable the mininum purchase quantity from store setting then each product showing same minimum
purchase quantity and to resolve this problem we use computed property. */
const showMinProductQuantity = computed(() => {
  if (selectedVariant.value) {
    return selectedVariant.value.min_pur_qty;
  } else {
    return props.product.min_pur_qty;
  }
});

const minValue = computed(() => {
  return props.product.min_pur_qty;
});

const hyperlinkColor = computed(() => {
  return {
    color: store.state.brand_skins['shop_hyperlink_bg_color'],
  };
});

const handleInput = (product) => {
  let inp = document.getElementById(product.id + '-quantity');
  if (inp.value == product.max_pur_qty) {
    toast.warning('This is the Maximum purchase quantity for this product');
    return;
  }

  // this check is added to check that only available inventory can be added if it tries to add more it will show an error
  if (product.hasVariants === true) {
    if (store.state.brand_settings['sell_soldout_products'] == 0 && (inp.value > selectedVariant.value.inventory) && product.ti == 1) {
      toast.error(`(${selectedVariant.value.sku}) has no more quantity to be added`);
      inp.value = selectedVariant.value.inventory;
      return;
    }
  } else {
    if (store.state.brand_settings['sell_soldout_products'] == 0 && (inp.value > product.inventory) && product.ti == 1) {
      toast.error(`(${product.sku}) has no more quantity to be added`);
      inp.value = product.inventory;
      return;
    }
  }

  if (store.state.brand['allow_multiple_of_minimum_purchase_quantity'] == "1" && (inp.value % product.min_pur_qty !== 0)) {
    toast.error(`Quantity must be a multiple of Minimum Purchase Quantity (${product.min_pur_qty}).`);
  }
};

const checkProductSoldOut = (product) => {
    buttonSoldOut.value = product.so;
};

const checkPriceTier = (product) => {
    if (!product.uses_volume_price_tiers) {
        productPrice.value = product.price ? product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }
    
    if (product.uses_volume_price_tiers && product.hasOwnProperty("low_price") && product.hasOwnProperty("high_price")) {
        productPrice.value = product.low_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
            '-' + product.currency_symbol + product.high_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } 
    
    else if (product.uses_volume_price_tiers && product.hasOwnProperty("price")) {
        productPrice.value = product.price ? product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }
};

const addProductToCart = (product) => {
  if (store.state.brand.restrict_single_category_order == 1) {
    const productObj = product.hasVariants ? selectedVariant.value : product;
    const cartProducts = store.state.cartProducts;
    const categoryId = product.cat_id ?? product.category?.id;

const hasDifferentCategoryProduct = cartProducts.some(cartProduct => 
      cartProduct.category_id !== categoryId 
    // May used in future 
    // && cartProduct?.category_name?.toLowerCase() !== "uncategorized"
    );
    if (hasDifferentCategoryProduct) {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "You cannot add products from different categories at the same time",
      });
      return;
    }
  }

  let inputQuantity = document.getElementById(product.id + '-quantity')?.value;
  inputQuantity = store.state.brand_settings['allow_decimal_order_quantity'] == "1" ? parseFloat(inputQuantity) : parseInt(inputQuantity);
  //Maximum Purchase Quantity does not greather than 6 digit  
  if (inputQuantity > ProductMaxQuantity.value) {
    toast.error('This Maximum purchase quantity for this product is 999999');//
    return;
  }

  else{ 
  let productId = product.id;
  setCartButton('btn btn-brand form-control', t('adding'), true);
  // TODO when parent fucntion hits api request on its result set button property to Add to cart
  if (product.hasVariants) {
    productId = selectedVariant.value?.id;
    if (!productId) {
      toast.warning('Select a Variant');
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
      return;
    }

    if (store.state.brand_settings['use_min_purchase_quantity'] == 1) {
      if (inputQuantity < selectedVariant.value.min_purchase_quantity) {
        toast.warning(`Quantity should not be less than ${selectedVariant.value.min_purchase_quantity}.`);//
        setCartButton('btn btn-danger form-control', t('error'), true);
        setTimeout(() => {
          setCartButton('btn btn-success form-control', t('add_to_cart'), false);
        }, 1000);
        return;
      }
    } else {
      if (inputQuantity < 0.1) {
        toast.warning(`Quantity should not be less than ${selectedVariant.value.min_purchase_quantity}.`);
        setCartButton('btn btn-danger form-control', t('error'), true);
        setTimeout(() => {
          setCartButton('btn btn-success form-control', t('add_to_cart'), false);
        }, 1000);
        return;
      }
    }
  }

  if (store.state.brand_settings['use_min_purchase_quantity'] == 1) {
    if (inputQuantity < product.min_pur_qty) {
      toast.warning(`Quantity should not be less than ${product.min_pur_qty}.`);
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
      return;
    }

  } else {
    if (inputQuantity < 0.1) {
      toast.warning(`Quantity should not be less than ${product.min_pur_qty}.`);
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
      return;
    }
  }

  if (product?.settings?.decimelOrderAllow == 0 || store.state.brand_settings['allow_decimal_order_quantity'] == 0) {
    const quantity = filterInt(inputQuantity);
    if (!Number.isInteger(quantity) || quantity < 1) {
      toast.warning('Quantity must be a number greater than zero.');
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
      return;
    }

  } else {
    const quantity = filterFloat(inputQuantity);
    if (isNaN(quantity) || quantity < 0.1) {
      toast.error('Quantity must be a positive number greater than zero.');
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
      return;
    }
  }

  if (store.state.brand['allow_multiple_of_minimum_purchase_quantity'] == "1" &&
      (inputQuantity % product.min_pur_qty !== 0)) {
    toast.error(`Quantity must be a multiple of Minimum Purchase Quantity ${product.min_pur_qty}.`);
    setCartButton('btn btn-danger form-control', t('error'), true);
    setTimeout(() => {
      setCartButton('btn btn-success form-control', t('add_to_cart'), false);
    }, 1000);
    return;
  }

  store.commit('SHOW_LOADER', true);
  ShopAPIService.addToCart({
    quantity: inputQuantity,
    productId: productId
  }).then((response) => {
    store.commit('SHOW_LOADER', false);
    if (response.data.hasOwnProperty("success")) {
      eventBus.emit('refreshCart');
      setCartButton('btn btn-success form-control ml-2', t('success'), true);
      toast.success(response.data.success);//
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
    } else if (response.data.hasOwnProperty("error")) {
      toast.error(response.data.error);//
      setCartButton('btn btn-danger form-control', t('error'), true);
      setTimeout(() => {
        setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
      }, 1000);
    }
  }).catch((error) => {
    store.commit('SHOW_LOADER', false);
    toast.error('Product not found');
    setCartButton('btn btn-danger form-control', t('error'), true);
    setTimeout(() => {
      setCartButton('btn btn-success form-control ml-2', t('add_to_cart'), false);
    }, 1000);
  });
}
};

const filterInt = (value) => {
            if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
                return Number(value);
            return NaN;
        };
const filterFloat = (value) => {
            if(/^\d+(\.\d{1,2})?$/.test(value))
                return Number(value);
            return NaN;
        };

const setAttributesQuantity = (quantityDisableValue, minValue, stepValue, value) => {
    quantityDisable.value = quantityDisableValue;
    min.value = minValue;
    step.value = stepValue;
    quantityValue.value = value;
};

const updateVariant = (selected_el) => {
    selectedVariant.value.min_purchase_quantity = store.state.brand_settings['allow_decimal_order_quantity'] === "1" 
        ? parseFloat(selectedVariant.value.min_purchase_quantity) 
        : parseInt(selectedVariant.value.min_purchase_quantity);
    
    let minQuantity = selectedVariant.value.min_pur_qty;

    minQuantity = (!minQuantity) ? 1 : minQuantity;
    checkPriceTier(selectedVariant.value);
    checkMinPurchaseQty(selectedVariant.value);
    checkProductSoldOut(selectedVariant.value);
};

const setCartButton = (btnClassValue, text, disable) => {
    btnClass.value = btnClassValue;
    btnText.value = text;
    cartDisable.value = disable;
};

const checkMinPurchaseQty = (product) => {
    if (props.settings.min_qty_multiples == '1') {
        setAttributesQuantity(false, product.min_pur_qty, product.min_pur_qty, product.min_pur_qty);
    } else {
        setAttributesQuantity(false, 1, 1, product.min_pur_qty);
    }
};

const disableCartButton = () => {
    if (props.product.hasVariants && selectedVariant.value === '') {
        cartDisable.value = true;
        quantityDisable.value = true;
    } else {
        cartDisable.value = false;
        quantityDisable.value = false;
    }
};

</script>
<style scoped>
    .demo-product-name {
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-size: 12px !important;
    }
    .productShopName{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 35ch;
    }
    .productShopDescription{
       overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       /*max-width: 300px;*/
       -webkit-line-clamp: 3; /* number of lines to show */
       -webkit-box-orient: vertical;
       padding-top:1rem;
       color: #595D6E;
       font-weight: 400;
      }
      .mx-table{
        width:auto;
    }
     .card.card-custom{
        background-color: #f9f9faad;
     }
    .bg-hover-state-custom {
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
    cursor: pointer; }
    .bg-hover-state-custom:hover {
    -webkit-transition: all 0.15s ease;
    transition: all 0.15s ease;
    box-shadow: 10px 10px 18px #d4d3d3;
    background-color: unset !important; 
}
    .card-header{
        border-bottom: 1px solid #cfcfcf !important;
        background-color: #efefef;
    }
    .card.card-custom > .card-header {
        /*background-color: #efefef;*/
    }
    .card.card-custom > .card-body{
        padding: 1.25rem;
    }
    .border-y , .border-y{
        color:#cfcfcf;
    }
    .text-truncate{
        width: 245px;
    }
    .custom-card{
        max-width: 300px;
        margin:0 auto;
        /*background-color: #cecece;*/
        max-height: 520px;
    }
    .img-fluid{
        max-width:250px;
        max-height: 250px;
        padding: 16px;
    }
    .unset-bg-color{
        border-color: unset;
    }

    .bg-img-height {
        height: 250px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        /*border-radius: 10px 10px 0 0;*/
        cursor: pointer; 
        vertical-align: top;
        position: relative;
    }
   .photo .overlay {
    background: rgba(41, 128, 185, 0.7);
    bottom: 0;
    color: white;
    font-size: 1em;
    left: 0;
    opacity: 0;
    overflow: hidden;
    padding: 3.75em 3em;
    position: absolute;
    text-align: center;
    top: 0;
    right: 0;
    -webkit-transition: 0.6s;
    transition: 0.6s;
    }
    .photo .overlay:hover {
    opacity: 1;
    }
    .photo .overlay p {
        font-size: 18px;
        margin-top: 70px;
    }
    .icon_style{
        padding: 4px 6px 4px 7px;
        color: #3699FF;
        background: #FFF;
        border: 1px solid #3699FF;
        border-radius: 50%;
        font-size: 9px;
    }
    .btn-primary, .btn-success, .btn-dark, .btn-danger, .btn-warning, .btn-light, .btn-info, .btn-secondary, .btn-outline-primary, .btn-light-primary{
     border-radius: 5px !important;
}
 .btn.btn-success {
     color: #ffffff;
     background-color: #1bac94;
     border-color: #1BC5BD;
     border-radius:0px;
}
 .btn.btn-success i {
     color: #ffffff;
}
 .btn.btn-success .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled), .btn.btn-success:focus:not(.btn-text), .btn.btn-success.focus:not(.btn-text) {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) i, .btn.btn-success:focus:not(.btn-text) i, .btn.btn-success.focus:not(.btn-text) i {
     color: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled) .svg-icon svg:hover g [fill], .btn.btn-success:focus:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success.focus:not(.btn-text) .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:hover:not(.btn-text):not(:disabled):not(.disabled).dropdown-toggle:after, .btn.btn-success:focus:not(.btn-text).dropdown-toggle:after, .btn.btn-success.focus:not(.btn-text).dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success.disabled, .btn.btn-success:disabled {
     color: #ffffff;
     background-color: #1BC5BD;
     border-color: #1BC5BD;
}
 .btn.btn-success.disabled i, .btn.btn-success:disabled i {
     color: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg g [fill], .btn.btn-success:disabled .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success.disabled .svg-icon svg:hover g [fill], .btn.btn-success:disabled .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success.disabled.dropdown-toggle:after, .btn.btn-success:disabled.dropdown-toggle:after {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text), .btn.btn-success:not(:disabled):not(.disabled).active, .show > .btn.btn-success.dropdown-toggle, .show .btn.btn-success.btn-dropdown {
     color: #ffffff;
     background-color: #0BB7AF;
     border-color: #0BB7AF;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) i, .btn.btn-success:not(:disabled):not(.disabled).active i, .show > .btn.btn-success.dropdown-toggle i, .show .btn.btn-success.btn-dropdown i {
     color: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
     fill: #ffffff;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text) .svg-icon svg:hover g [fill], .btn.btn-success:not(:disabled):not(.disabled).active .svg-icon svg:hover g [fill], .show > .btn.btn-success.dropdown-toggle .svg-icon svg:hover g [fill], .show .btn.btn-success.btn-dropdown .svg-icon svg:hover g [fill] {
     -webkit-transition: fill 0.3s ease;
     transition: fill 0.3s ease;
}
 .btn.btn-success:not(:disabled):not(.disabled):active:not(.btn-text).dropdown-toggle:after, .btn.btn-success:not(:disabled):not(.disabled).active.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle.dropdown-toggle:after, .show .btn.btn-success.btn-dropdown.dropdown-toggle:after {
     color: #ffffff;
}
 
@media (max-width: 768px) {
    .mobile-grid-variant-select {
        position: relative;
        width: 100%;
        min-width: 0;
    }
    .mobile-grid-variant-select::after {
        content: "";
        position: absolute;
        z-index: 2;
        top: 1px;
        right: 1px;
        bottom: 1px;
        width: 28px;
        background-color: #fff;
        pointer-events: none;
    }
    .mobile-grid-variant-select::before {
        content: "";
        position: absolute;
        z-index: 3;
        top: 50%;
        right: 9px;
        border: 4px solid transparent;
        border-top-color: #6c757d;
        transform: translateY(-25%);
        pointer-events: none;
    }
    .mobile-grid-variant-select select {
        width: 100%;
        min-width: 0;
        max-width: 100%;
        padding-right: 32px !important;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    @supports (appearance: base-select) {
        .mobile-grid-variant-select select,
        .mobile-grid-variant-select select::picker(select) {
            appearance: base-select;
        }
        .mobile-grid-variant-select select::picker-icon {
            display: none;
        }
        .mobile-grid-variant-select select::picker(select) {
            inline-size: anchor-size(width);
            min-inline-size: anchor-size(width);
            max-inline-size: anchor-size(width);
            max-height: 60vh;
            box-sizing: border-box;
            overflow-y: auto;
        }
        .mobile-grid-variant-select .variant-select-button {
            display: flex;
            align-items: center;
            width: 100%;
            min-width: 0;
            overflow: hidden;
            border: 0;
            padding: 0;
            background: transparent;
            color: inherit;
            font: inherit;
            text-align: left;
        }
        .mobile-grid-variant-select .variant-selected-content {
            display: block;
            width: 100%;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 400 !important;
        }
        .mobile-grid-variant-select .variant-selected-content * {
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: inherit;
        }
        .mobile-grid-variant-select select option {
            min-width: 0;
            max-width: 100%;
            height: auto;
            overflow: visible;
            white-space: normal;
            overflow-wrap: anywhere;
            font-weight: 400 !important;
            line-height: 1.25;
        }
        .mobile-grid-variant-select select option * {
            margin: 0;
            max-width: 100%;
            overflow: visible;
            white-space: normal;
            overflow-wrap: anywhere;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: inherit;
        }
    }
    .mobile-list-card,
    .mobile-list-card > .card-body,
    .mobile-list-card .datatable,
    .mobile-product-list,
    .mobile-product-list .datatable-body,
    .mobile-product-list .datatable-row,
    .mobile-product-list .datatable-cell {
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
    }
    .mobile-list-card > .card-body {
        padding: 0.75rem;
        overflow: visible;
    }
    .mobile-product-list,
    .mobile-product-list .datatable-body {
        display: block !important;
        visibility: visible !important;
        position: static !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: visible !important;
    }
    .mobile-product-list .datatable-row {
        display: grid !important;
        visibility: visible !important;
        position: static !important;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-auto-rows: max-content;
        overflow: visible !important;
        align-items: center;
        gap: 0.75rem;
        width: 100% !important;
        min-width: 0 !important;
        padding: 0.5rem 0;
    }
    .mobile-product-list .datatable-cell {
        display: block !important;
        visibility: visible !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: 100% !important;
        padding: 0 !important;
    }
    .mobile-product-list .datatable-cell:nth-child(1) {
        grid-column: 1 / 3;
        grid-row: 1;
    }
    .mobile-product-list .datatable-cell:nth-child(2) {
        grid-column: 3 / 4;
        grid-row: 1;
        text-align: right;
    }
    .mobile-product-list .datatable-cell:nth-child(3) {
        grid-column: 1 / 2;
        grid-row: 2;
    }
    .mobile-product-list .datatable-cell:nth-child(4) {
        grid-column: 1 / -1;
        grid-row: 3;
    }
    .mobile-product-list .datatable-cell:nth-child(4):empty {
        display: none !important;
    }
    .mobile-product-list .datatable-cell:nth-child(5) {
        grid-column: 2 / 4;
        grid-row: 2;
    }
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(3) {
        grid-column: 1 / -1;
        grid-row: 2;
    }
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(3) > span,
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(3) > span > .d-flex,
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(3) > span > .d-flex > div {
        width: 100% !important;
        min-width: 0;
        max-width: 100%;
        overflow: visible !important;
    }
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(5) {
        grid-column: 1 / -1;
        grid-row: 3;
    }
    .mobile-product-list .mobile-variant-row .datatable-cell:nth-child(4) {
        grid-row: 4;
    }
    .mobile-product-list .datatable-cell > span {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: visible !important;
    }
    .mobile-product-list .datatable-cell:first-child .d-flex,
    .mobile-product-list .datatable-cell:first-child .ml-4 {
        min-width: 0;
    }
    .mobile-product-list .datatable-cell:first-child a {
        display: -webkit-box;
        overflow: hidden;
        white-space: normal;
        overflow-wrap: anywhere;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .mobile-product-list .datatable-cell:nth-child(2) > span {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .mobile-product-list .datatable-cell:nth-child(5) .row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 0.75rem;
        width: 100% !important;
        margin: 0;
    }
    .mobile-product-list .datatable-cell:nth-child(5) .col-md-6 {
        min-width: 0;
        padding: 0;
    }
    .mobile-product-list .datatable-cell:nth-child(5) .col-md-6:first-child,
    .mobile-product-list .datatable-cell:nth-child(5) .col-md-6:last-child {
        flex: 1 1 0;
        width: 50%;
        max-width: 50%;
    }
    .mobile-product-list .datatable-cell:nth-child(5) input {
        width: 100% !important;
        min-width: 0;
    }
    .mobile-product-list .datatable-cell:nth-child(5) button {
        width: 100% !important;
        max-width: 100%;
        white-space: nowrap;
    }
    .mobile-product-list .datatable-cell:nth-child(3) select {
        width: 100%;
        min-width: 0;
        max-width: 100%;
        box-sizing: border-box;
        padding-right: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    @supports (appearance: base-select) {
        .mobile-product-list .datatable-cell:nth-child(3) select,
        .mobile-product-list .datatable-cell:nth-child(3) select::picker(select) {
            appearance: base-select;
        }
        .mobile-product-list .datatable-cell:nth-child(3) select {
            position: relative;
            display: block;
            padding-right: 32px;
            overflow: hidden;
        }
        .mobile-product-list .variant-select-button {
            display: flex;
            align-items: center;
            width: 100%;
            min-width: 0;
            overflow: hidden;
            border: 0;
            padding: 0;
            background: transparent;
            color: inherit;
            font: inherit;
            text-align: left;
        }
        .mobile-product-list .variant-selected-content {
            display: block;
            width: 100%;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 400 !important;
        }
        .mobile-product-list .variant-selected-content * {
            margin: 0;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: inherit;
        }
        .mobile-product-list .datatable-cell:nth-child(3) select::picker(select) {
            width: anchor-size(width);
            min-width: anchor-size(width);
            max-width: anchor-size(width);
            max-height: 60vh;
            box-sizing: border-box;
            overflow-y: auto;
        }
        .mobile-product-list .datatable-cell:nth-child(3) select::picker-icon {
            position: absolute;
            top: 50%;
            right: 10px;
            margin: 0;
            transform: translateY(-50%);
        }
        .mobile-product-list .datatable-cell:nth-child(3) select option {
            min-width: 0;
            max-width: 100%;
            white-space: normal;
            overflow-wrap: anywhere;
            font-weight: 400 !important;
        }
        .mobile-product-list .datatable-cell:nth-child(3) select option * {
            margin: 0;
            font-size: inherit !important;
            font-weight: 400 !important;
            line-height: inherit;
        }
    }
}
</style>

